module.exports = __webpack_public_path__ + "assets/question-small.svg";